var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"mt-3 category-product-list p-0 m-0 products-bordered"},_vm._l((8),function(n){return _c('li',{key:n,staticClass:"placeholder item d-flex align-items-stretch placeholder-pdt"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }